import { lazy, Suspense } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Toaster } from 'sonner';
import { LoadingPage } from '@/components/common/LoadingPage';

const LoginPage = lazy(() => import('@/pages/auth/LoginPage/LoginPage'));
const EmailOtpPage = lazy(() => import('@/pages/auth/EmailOtpPage/EmailOtpPage'));
const TotpSetupPage = lazy(() => import('@/pages/auth/TotpSetupPage/TotpSetupPage'));
const TotpVerifyPage = lazy(() => import('@/pages/auth/TotpVerifyPage/TotpVerifyPage'));
const BackupCodePage = lazy(() => import('@/pages/auth/BackupCodePage/BackupCodePage'));
const DashboardPage = lazy(() => import('@/pages/dashboard/DashboardPage/DashboardPage'));
const UsersListPage = lazy(() => import('@/pages/users/UsersListPage/UsersListPage'));
const UserDetailPage = lazy(() => import('@/pages/users/UserDetailPage/UserDetailPage'));
const ProjectsListPage = lazy(() => import('@/pages/projects/ProjectsListPage/ProjectsListPage'));
const ProjectDetailPage = lazy(
  () => import('@/pages/projects/ProjectDetailPage/ProjectDetailPage'),
);
const AuditPage = lazy(() => import('@/pages/audit/AuditPage/AuditPage'));
const HealthPage = lazy(() => import('@/pages/system/HealthPage/HealthPage'));
const ErrorsListPage = lazy(() => import('@/pages/errorTracking/ErrorsListPage/ErrorsListPage'));
const ErrorDetailPage = lazy(() => import('@/pages/errorTracking/ErrorDetailPage/ErrorDetailPage'));
const NotFoundPage = lazy(() => import('@/pages/errors/NotFoundPage'));
const IpBlockedPage = lazy(() => import('@/pages/errors/IpBlockedPage'));
const ServerErrorPage = lazy(() => import('@/pages/errors/ServerErrorPage'));

const ProtectedAdminRoute = lazy(() => import('@/components/layout/ProtectedAdminRoute'));
const AdminLayout = lazy(() => import('@/components/layout/AdminLayout'));

export function Router() {
  return (
    <BrowserRouter>
      <Suspense fallback={<LoadingPage />}>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/email-otp" element={<EmailOtpPage />} />
          <Route path="/setup-totp" element={<TotpSetupPage />} />
          <Route path="/verify-totp" element={<TotpVerifyPage />} />
          <Route path="/use-backup-code" element={<BackupCodePage />} />
          <Route path="/ip-blocked" element={<IpBlockedPage />} />
          <Route path="/500" element={<ServerErrorPage />} />

          <Route
            element={
              <ProtectedAdminRoute>
                <AdminLayout />
              </ProtectedAdminRoute>
            }
          >
            <Route index element={<DashboardPage />} />
            <Route path="/users" element={<UsersListPage />} />
            <Route path="/users/:id" element={<UserDetailPage />} />
            <Route path="/projects" element={<ProjectsListPage />} />
            <Route path="/projects/:id" element={<ProjectDetailPage />} />
            <Route path="/audit" element={<AuditPage />} />
            <Route path="/errors" element={<ErrorsListPage />} />
            <Route path="/errors/:id" element={<ErrorDetailPage />} />
            <Route path="/system/health" element={<HealthPage />} />
          </Route>

          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Suspense>
      <Toaster richColors theme="dark" position="bottom-right" />
    </BrowserRouter>
  );
}
